export const Resources = {
  globalSearch: {
    url: "/devices/global_search",
    asyncActions: {
      init: "globalSearch_INIT",
      success: "globalSearch_SUCCESS",
      error: "globalSearch_ERROR"
    }
  }
};

const initialState = {
  list: undefined,
  links: undefined,
  status: undefined,
  statusText: undefined,
  meta: undefined,
  devices: []
};

export function updateSearchResultData(data) {
  return (dispatch, getState) => {
    const state = getState().globalSearchResults;
    state.list = undefined;
    state.newDevices = data;
    state.newCampaigns = data;
    state.newContents = data;
    dispatch({
      type: "update_list-data",
      payload: state
    });
  };
}

export function updateGroupInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newDevices } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { devices } = list[0];
    state.list[0].devices = [...newDevices, ...devices];
    dispatch({
      type: "global_infinite_group-scroll_device",
      payload: state
    });
  };
}

export function updateCampaignInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newCampaigns } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { campaigns } = list[0];
    state.list[0].campaigns = [...newCampaigns, ...campaigns];
    dispatch({
      type: "global_infinite_group-scroll_campaign",
      payload: state
    });
  };
}

export function updateContentInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newContents } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { contents } = list[0];
    state.list[0].contents = [...newContents, ...contents];
    dispatch({
      type: "global_infinite_group-scroll_content",
      payload: state
    });
  };
}

export function updatePlaylistInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newPlaylists } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { playlists } = list[0];
    state.list[0].playlists = [...newPlaylists, ...playlists];
    dispatch({
      type: "global_infinite_group-scroll_playlist",
      payload: state
    });
  };
}

export function updateCalendarInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newCalendars } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { calendars } = list[0];
    state.list[0].calendars = [...newCalendars, ...calendars];
    dispatch({
      type: "global_infinite_group-scroll_calendar",
      payload: state
    });
  };
}

export function updateUserInfiniteScroll() {
  return (dispatch, getState) => {
    const { list, newUsers } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    const { users } = list[0];
    state.list[0].users = [...newUsers, ...users];
    dispatch({
      type: "global_infinite_group-scroll_user",
      payload: state
    });
  };
}

export function updateGlobalSearchDeviceStatusWS(status, data) {
  return (dispatch, getState) => {
    const { list } = getState().globalSearchResults;
    const state = getState().globalSearchResults;
    if (list) {
      const { devices } = list[0];
      if (devices) {
        devices.map(item => {
          if (item.mac_address === data.mac) {
            // make a changes
            item.status = data.status;
          }
        });
        state.list = list;
      }
      dispatch({
        type: "updateGlobalListThroughWS",
        payload: state
      });
    }
  };
}

export function globalSearchResults(state = { ...initialState }, action = {}) {
  const { init, success, error } = Resources.globalSearch.asyncActions;

  switch (action.type) {
    case init: {
      return {
        ...state,
        loading: true,
        hasError: undefined
      };
    }

    case success: {
      const {
        data: { data, meta },
        status
      } = action.payload;

      return {
        list: data,
        newDevices: state.list && state.list[0].devices,
        newCampaigns: state.list && state.list[0].campaigns,
        newContents: state.list && state.list[0].contents,
        newPlaylists: state.list && state.list[0].playlists,
        newCalendars: state.list && state.list[0].calendars,
        newUsers: state.list && state.list[0].users,
        status,
        meta,
        hasList: true,
        loading: false,
        hasError: false
      };
    }
    case error: {
      return {
        ...state,
        loading: false,
        hasError: true
      };
    }

    case "update_list-data": {
      return {
        ...action.payload
      };
    }

    case "updateGlobalListThroughWS": {
      return {
        ...action.payload
      };
    }

    case "global_infinite_group-scroll_device": {
      return {
        ...action.payload
      };
    }
    case "global_infinite_group-scroll_campaign": {
      return {
        ...action.payload
      };
    }
    case "global_infinite_group-scroll_content": {
      return {
        ...action.payload
      };
    }
    case "global_infinite_group-scroll_playlist": {
      return {
        ...action.payload
      };
    }
    case "global_infinite_group-scroll_calendar": {
      return {
        ...action.payload
      };
    }
    case "global_infinite_group-scroll_user": {
      return {
        ...action.payload
      };
    }

    default: {
      return state;
    }
  }
}
